module.exports = __webpack_public_path__ + "static/media/angle-right.239b9721.svg";